import axios from 'axios';

import { getCookie, setCookie } from '@/utils/cookie';

export type SignupParams = {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  companyName?: string;
};

export type AccessTokenType = {
  accessToken: string;
  refreshToken: string;
  token?: never;
};

export interface LoginRequestOptions {
  email: string;
}

export interface LoginResponse {
  message: string;
}

export interface RefreshRequestOptions {
  refreshToken: string;
  accessToken: string;
}
export const loginRequest = async ({ email }: LoginRequestOptions): Promise<LoginResponse> => {
  const { data } = await axios.post('protected/login', {
    email
  });
  return data;
};

export const signupRequest = async ({ email, firstName, lastName, password, companyName }: SignupParams): Promise<void> => {
  await axios.post('/authenticate/signup/request', {
    email,
    password,
    firstName,
    lastName,
    companyName
  });
};

export const refreshTokenRequest = async (): Promise<void> => {
  const { data } = await axios.post('/protected/refresh', {
    refreshToken: getCookie('refreshToken'),
    accessToken: getCookie('accessToken')
  });

  setCookie('accessToken', data.accessToken);
  setCookie('refreshToken', data.refreshToken);

  return data;
};
